<template>
  <div>
    <div class="banner_img min-container" />
    <div class="container upcoming-content home-p-color">
      <pp-steps :step="1" />

      <div class="content center-margin">
        <div class="step">
          <h2 class="title center-aligned">
            {{ $t('ppwc.p7') }}
          </h2>
          <el-form
            ref="ruleForm"
            :model="param"
            :rules="rules"
            label-width="0px"
            class="demo-ruleForm"
          >
            <el-form-item prop="serial_no">
              <el-row
                type="flex"
                justify="center"
              >
                <el-col :span="22">
                  <el-input
                    v-model.trim="param.serial_no"
                    :placeholder="$t('ppwc.p8')"
                    class="serial_input"
                  />
                </el-col>
                <el-col :span="2">
                  <img
                    class="question"
                    src="/official/static/img/events/activate/1/question.png"
                    @click.prevent="show_serial"
                  >
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item prop="ticket_no">
              <el-row
                type="flex"
                justify="center"
              >
                <el-col :span="22">
                  <el-input
                    v-model.trim="param.ticket_no"
                    :placeholder="$t('ppwc.p9')"
                    class="ticket_input"
                  />
                </el-col>
                <el-col :span="2">
                  <img
                    class="question"
                    src="/official/static/img/events/activate/1/question.png"
                    @click.prevent="show_ticket"
                  >
                </el-col>
              </el-row>
            </el-form-item>
            <div
              class="confirm"
              @click="submitForm('ruleForm')"
            >
              <p>{{ $t('ppwc.p12') }}</p>
            </div>
            <p
              v-show="tips"
              class="error_tips"
            >
              {{ tips }}
            </p>
          </el-form>

          <div
            v-if="show"
            class="pops"
            @click="closePop"
          >
            <div class="dark" />
            <div class="pop">
              <img
                v-show="showSerialPhoto"
                class="question"
                src="/official/static/img/events/activate/1/p1.png"
              >
              <img
                v-show="!showSerialPhoto"
                class="question"
                src="/official/static/img/events/activate/1/p2.png"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ticketVerify
} from '@/api/official'
import ppSteps from './ppSteps'

export default {
  components: {
    ppSteps
  },
  props: {
    param: {
      type: Object,
      default: {
        serial_no: '',
        ticket_no: ''
      }
    }
  },
  data() {
    return {
      show: false,
      showSerialPhoto: true,
      tips: '',
      showSerialPhoto: true,
      rules: {
        serial_no: [
          { required: true, message: this.$t('ppwc.p10'), trigger: 'blur' },
        ],
        ticket_no: [
          { required: true, message: this.$t('ppwc.p11'), trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    show_serial() {
      this.showSerialPhoto = true
      this.show = true
    },
    show_ticket() {
      this.showSerialPhoto = false
      this.show = true
    },
    closePop() {
      this.show = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          ticketVerify({ ...this.param })
            .then(res => {
              if(res.code == 0) {
                if(res.data) {
                  this.$emit('setStep', 5, res.data)
                }else {
                  this.$emit('setStep', 2, this.param)  
                }
              }else if(res.code == '-10001') {
                // $('.form1').form('add errors', [res.msg])  
                // console.log(res.msg)
                this.tips = this.$t('ppwc.p13')
              }else {
                // $('.form1').form('add errors', ['network issue, Please try again later.'])  
                this.tips = 'network issue, Please try again later'
              }
            })
            .catch(err => {
              // console.log(err)
              this.tips = this.$t('ppwc.p13')
            })
        } else {
          this.tips = ""
          return false;
        }
      });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.banner_img {
  height: 410px;
  width: 100%;
  background: url("/official/static/img/events/banner1.jpg") center center;
  background-repeat: no-repeat;
}
.upcoming-content {
  padding-top: 65px;
  padding-bottom: 65px;
  .content {
    width: 620px;
  }
}
.step {
  .title {
    font-size: 26px;
    margin: 0px 0px 30px 0px;
  }
  /deep/.demo-ruleForm {
    input::-webkit-input-placeholder{   /* 使用webkit内核的浏览器 */
      font-weight: normal;
    }
    input:-moz-placeholder{    /* Firefox版本4-18 */
      font-weight: normal;
      color: #C0C4CC;
    }              
    input::-moz-placeholder{    /* Firefox版本19+ */
      font-weight: normal;
      color: #C0C4CC;
    }              
    input:-ms-input-placeholder{   /* IE浏览器 */
      font-weight: normal;
      color: #C0C4CC;
    }   
  }
  .demo-ruleForm {
    width: 520px;
    margin: 0px auto;
    .el-form-item {
      margin-bottom: 30px;
    }
    /deep/.el-input__inner {
      font-weight: bold;
      font-size: 18px;
      height: 54px;
      color: #1f9d56;
    }
    /deep/.el-form-item__error {
      font-weight: bold;
    }
    .ticket_input {
      /deep/.el-input__inner {
        padding-left: 45px;
        background: url('/official/static/img/events/activate/1/ticket_g.png') no-repeat 14px center;
        background-size: 22px auto;
      }
    }
    .serial_input {
      /deep/.el-input__inner {
        padding-left: 45px;
        background: url('/official/static/img/events/activate/1/no_g.png') no-repeat 14px center;
        background-size: 22px auto;
      }
    }
    /deep/.el-form-item.is-error {
      .el-input__inner {
        color: #942321;
        font-weight: normal;
      }
    }
    .question {
      float: right;
      margin-top: 14px;
      margin-right: 12px;
    }
  }
  .confirm {
    position: relative;
    width: 223px;
    height: 42px;
    margin: 44px auto 0px auto;
    background: url('/official/static/img/events/activate/banner_01.png') no-repeat center center;
    background-size: 100%;
    cursor: pointer;
    p {
      text-align: center;
      line-height: 42px;
      font-size: 24px;
      color: #fff;
    }
  }

  .error_tips {
    color: #942321;
    font-size: 16px;
    padding: 0px 6px;
    // border: 1px solid #942321;
    margin-top: 20px;
    text-align: center;
  }

  .pops {
    position: fixed;
    top: 40%;
    left: 50%;
    width: 501px;
    height: 167px;
    margin-left: -251px;
    z-index: 3000;
    .dark {
      background-color: #000000;
      filter: Alpha(opacity=80);
      -moz-opacity: 0.8;
      opacity: 0.8;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9;
    }
    .pop {
      position: relative;
      z-index: 3500;
    }
  }
}
</style>
